// CKEditor 4 はプラグインや言語ファイル、スキンを CKEDITOR_BASEPATH から読むので、本体より先に webpack がコピーした場所を教える
// ページのドメインから読むとデプロイの途中にファイルの無い古いサーバへ振り分けられて 404 になるので、pack と同じ CDN から読む
window.CKEDITOR_BASEPATH = new URL(
  `${__webpack_public_path__}ckeditor4/`,
  document.currentScript?.src ?? window.location.href,
).href;
